import React, { useEffect, useState } from 'react';
import HeroProfile from '../../../components/hero/HeroProfile';
import SidebarProfile from '../../../components/sidebars/SidebarProfile';
import useDocumentTitle from '../../../components/useDocumentTitle';
import { useLocation } from 'react-router-dom';
import { getUserByAddress } from '../../../hooks/User';
import OwnAssetProfile from '../../../components/cards/profile/OwnProfile';
import CreatedAssetProfile from '../../../components/cards/profile/CreatredAssetProfile';
import CollectionProfile from '../../../components/cards/profile/CollectionProfile';
import ProfileAuction from '../auction/ProfileAuction';
import CollectionDraft from '../../../components/cards/profile/CollectionDraft';
import NFTDraft from '../../../components/cards/profile/NFTDraft';
import toast from 'react-hot-toast';
import { handleApiError, retryApiCall } from '../../../utils/apiUtils';

const Profile = () => {
  useDocumentTitle('Profile');
  const [user, setUser] = useState({});
  const [selectedTab, setSelectedTab] = useState(0); // Main tabs
  const [draftSubTab, setDraftSubTab] = useState(0); // Sub-tabs for Draft
  const location = useLocation();

  const walletAddress = localStorage.getItem('WalletAddress');

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setIsLoading(true);
        const data = await retryApiCall(
          () => getUserByAddress(walletAddress),
          3,
          1000
        );
        if (!data || data.status !== 200) {
          throw new Error(data?.message || 'Failed to fetch user data');
        }
        setUser(data.user);
      } catch (error) {
        handleApiError(error, 'Failed to load user profile');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [walletAddress]);

  useEffect(() => {
    const receivedData = location.state;
    if (receivedData === 'draft') {
      setSelectedTab(3); // Activate the Drafts tab
    }
  }, [location.state]);

  const renderDraftsContent = () => {
    return (
      <div>
        <div className="d-flex mb-3">
          <button
            className={`btn btn-sm mr-2 ${draftSubTab === 0 ? 'active btn-primary' : 'btn-white'}`}
            onClick={() => setDraftSubTab(0)}
          >
            NFT Drafts
          </button>
          <button
            className={`btn btn-sm ${draftSubTab === 1 ? 'active btn-primary' : 'btn-white'}`}
            onClick={() => setDraftSubTab(1)}
          >
            Collection Drafts
          </button>
        </div>
        <div>
          {draftSubTab === 0 ? <NFTDraft /> : <CollectionDraft />}
        </div>
      </div>
    );
  };

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        return <OwnAssetProfile user={user} address={walletAddress}   />;
      case 1:
        return <CreatedAssetProfile user={user} address={walletAddress} />;
      case 2:
        return <CollectionProfile user={user} address={walletAddress} />;
      case 3:
        return renderDraftsContent(); // Drafts tab
      case 4:
        return <ProfileAuction />;
      default:
        return <OwnAssetProfile user={user} address={walletAddress} />;
    }
  };
  console.log("Address", walletAddress, user);
  

  return (
    <div>
      <HeroProfile address={walletAddress} />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-3 col-md-7 order-md-0 order-1">
            <SidebarProfile user={user} address={walletAddress} />
          </div>
          <div className="col-lg-9 col-md-12 order-md-1 order-0">
            <div className="profile__content">
              <div className="d-flex justify-content-between">
                <div className="nav-tabs">
                  <button
                    className={`btn btn-sm mr-2 ${selectedTab === 0 ? 'active btn-primary' : 'btn-white'}`}
                    onClick={() => setSelectedTab(0)}
                  >
                    Owned
                  </button>
                  <button
                    className={`btn btn-sm mr-2 ${selectedTab === 1 ? 'active btn-primary' : 'btn-white'}`}
                    onClick={() => setSelectedTab(1)}
                  >
                    Created
                  </button>
                  <button
                    className={`btn btn-sm mr-2 ${selectedTab === 2 ? 'active btn-primary' : 'btn-white'}`}
                    onClick={() => setSelectedTab(2)}
                  >
                    Collections
                  </button>
                  <button
                    className={`btn btn-sm mr-2 ${selectedTab === 3 ? 'active btn-primary' : 'btn-white'}`}
                    onClick={() => setSelectedTab(3)}
                  >
                    Drafts
                  </button>
                  <button
                    className={`btn btn-sm mr-2 ${selectedTab === 4 ? 'active btn-primary' : 'btn-white'}`}
                    onClick={() => setSelectedTab(4)}
                  >
                    Auction
                  </button>
                </div>
              </div>

              {/* Conditionally render content based on the selected tab */}
              <div className="tab-content mt-3">{renderContent()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
